class HomeVideo {
    constructor(root) {
        this.root = root;

        this.playButton = this.root.querySelector('[data-id="widget-home-video__play-button"]');
        this.imagePlaceholder = this.root.querySelector('[data-id="widget-home-video__image-placeholder"]');
        this.videoPlaceholder = this.root.querySelector('[data-id="widget-home-video__video-placeholder"]');

        if (!this.playButton || !this.imagePlaceholder || !this.videoPlaceholder) {
            return;
        }

        this.playButton.addEventListener('click', () => this.onPlayButtonClick());
    }

    onPlayButtonClick() {
        this.imagePlaceholder.style.display = 'none';
        
        let _div = this.videoPlaceholder.querySelector('.youtube-player');
        if (_div) {
            let youtubeId = _div.getAttribute('data-id');
            let iframe = document.createElement('iframe');
            iframe.setAttribute('src', `https://www.youtube.com/embed/${youtubeId}?autoplay=1`);
            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
            iframe.setAttribute('allowfullscreen', 'true');
            iframe.classList.add('absolute', 'inset-0', 'w-full', 'h-full', 'object-cover');
            this.videoPlaceholder.innerHTML = '';
            this.videoPlaceholder.appendChild(iframe);
        } else {
             let video = this.videoPlaceholder.querySelector('video');
             if (video) {
                 video.play();
             }
        }

        this.videoPlaceholder.style.display = 'block';
    }
}

export default HomeVideo;